// extracted by mini-css-extract-plugin
export default {"TrayButton":"TrayButton_TrayButton__n7qYO","ButtonLabel":"TrayButton_ButtonLabel__NIuPa","Icon":"TrayButton_Icon__X3itb","open":"TrayButton_open__X1jb1"};